"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingCloudUser = void 0;
const types_1 = require("../types");
const SportradarEnforcerFactory_1 = require("../Factories/SportradarEnforcerFactory");
const SportradarResourceName_1 = require("../SportradarResource/SportradarResourceName");
const FeatureToggleMiddleware_1 = require("../Middlewares/FeatureToggleMiddleware");
const ActionValidationMiddlewareFactory_1 = require("../Factories/ActionValidationMiddlewareFactory");
class MarketingCloudUser {
    cognitoId;
    principalId;
    holdingIds;
    businessEntityIds = [];
    roles = [];
    internalRole = null;
    policies = [];
    allowedApplications = [];
    constructor(self) {
        Object.assign(this, self);
    }
    isAdmin() {
        return this.roles.includes('sr-admin');
    }
    async canRead(domain, resourceType) {
        return this.canAccess(types_1.ACTION_NAME.READ, resourceType, domain);
    }
    async canCreate(domain, resourceType) {
        return this.canAccess(types_1.ACTION_NAME.CREATE, resourceType, domain);
    }
    async canEdit(domain, resourceType) {
        return this.canAccess(types_1.ACTION_NAME.EDIT, resourceType, domain);
    }
    async canEditSharedResource(domain, resourceType) {
        return this.canAccessSharedResource(types_1.ACTION_NAME.EDIT, resourceType, domain);
    }
    async canRemove(domain, resourceType) {
        return this.canAccess(types_1.ACTION_NAME.REMOVE, resourceType, domain);
    }
    async can(action) {
        const actionWithUserId = { ...action, userId: this.principalId };
        const actionValidationMiddleware = await ActionValidationMiddlewareFactory_1.ActionValidationMiddlewareFactory.fromMarketingCloudUser(this);
        return actionValidationMiddleware.validateAction(actionWithUserId);
    }
    async hasFeature(featureIdentifier) {
        const sportradarEnforcerFactory = new SportradarEnforcerFactory_1.SportradarEnforcerFactory();
        const enforcer = await sportradarEnforcerFactory.createFromMarketingCloudUser(this);
        const featureToggleMiddleware = new FeatureToggleMiddleware_1.FeatureToggleMiddleware(enforcer);
        return featureToggleMiddleware.hasFeature(this.principalId, featureIdentifier);
    }
    serialize() {
        return JSON.stringify({
            cognitoId: this.cognitoId,
            principalId: this.principalId,
            holdingIds: this.holdingIds,
            businessEntityIds: this.businessEntityIds,
            roles: this.roles,
            internalRole: this.internalRole,
            policies: this.policies,
            allowedApplications: this.allowedApplications,
        });
    }
    async canAccess(actionName, resourceType, domainName) {
        return this.can({
            actionName,
            domainName,
            resourceType,
        });
    }
    async canAccessSharedResource(actionName, resourceType, domainName) {
        return this.can({
            actionName,
            resourceType,
            domainName,
            holdingId: SportradarResourceName_1.SportradarResourceName.sharedIdentifier,
            businessEntityId: SportradarResourceName_1.SportradarResourceName.sharedIdentifier,
        });
    }
    /**
     * @deprecated will be removed in major version when fully switched to Common IAM. Use getPrincipalId() instead.
     */
    getCognitoId() {
        return this.cognitoId;
    }
    getPrincipalId() {
        return this.principalId;
    }
    getHoldingIds() {
        return this.holdingIds;
    }
    getBusinessEntityIds() {
        return this.businessEntityIds;
    }
    getRoles() {
        return this.roles;
    }
    getPolicies() {
        return this.policies;
    }
    getAllowedApplications() {
        return this.allowedApplications;
    }
    getInternalRole() {
        return this.internalRole;
    }
}
exports.MarketingCloudUser = MarketingCloudUser;
//# sourceMappingURL=MarketingCloudUser.js.map